import { SxProps, Theme } from "@mui/material";

export const root: SxProps<Theme> = {
	display: "flex",
	flexDirection: "column",
	overflowY: "auto",
	flex: 1,
};
